import ReactOnRails from 'react-on-rails';
import DogRescuesProfile from '../../bundles/DogRescuesProfile/components/DogRescuesProfile.client.jsx';

ReactOnRails.register({DogRescuesProfile});
